import Vue from "vue";
import Router from "vue-router";
import NotFound from "./views/pages/NotFound.vue";
import SetToken from "./views/pages/SetToken.vue";
// WEB
import HomePage from "@/views/pages/HomePage.vue";
// WAP
import MainNavBarWap from "./layout/Wap/MainNavBar.vue";
import MainNavBar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";
import CoursesPage from "./views/pages/Courses/Courses.vue";
import DetailCourses from "./views/pages/Courses/components/Detail.vue";
import Orders from "./views/pages/Orders/Index.vue";
import Carts from "./views/pages/Orders/Carts.vue";

// import AppFooterWap from "./layout/Wap/AppFooter.vue";
// import AppFooterWapMobiMath from "./layout/Wap-mobiMath/AppFooter.vue";
 import MainNavBarWapMobiMath from "./layout/Wap-mobiMath/MainNavBar.vue";
// import HomePageWapMobiMath from "@/views/pages/wap-mobiMath/HomePage.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/404",
      name: "404",
      components: {
        default: NotFound
      }
    },
    {
      path: "/",
      name: "homepage",
      components: {
        default: HomePage,
        header: "",
        footer: MainFooter
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/About",
      name: "About",
      components: {
        default: HomePage,
        header: "",
        footer: ""
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/Pages",
      name: "Pages",
      components: {
        default: HomePage,
        header: "",
        footer: ""
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/Courses/:course_topic_id?",
      name: "Courses",
      components: {
        default: CoursesPage,
        header: MainNavBar,
        footer: MainFooter
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/my-courses",
      name: "MyCourses",
      components: {
        default: CoursesPage,
        header: MainNavBar,
        footer: MainFooter
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/Courses/Detail/:coursesId",
      name: "DetailCourses",
      components: {
        default: DetailCourses,
        header: MainNavBar,
        footer: MainFooter
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/Orders",
      name: "Orders",
      components: {
        default: Orders,
        header: MainNavBar,
        footer: MainFooter
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/Carts",
      name: "Carts",
      components: {
        default: Carts,
        header: MainNavBar,
        footer: MainFooter
      },
      props: {
        header: { colorOnScroll: 100 },
        footer: { backgroundColor: "black" }
      }
    }
    // {
    //   path: "/about-us",
    //   name: "about-us",
    //   components: {
    //     default: AboutUsMobiMath,
    //     header: MainNavBarWapMobiMath,
    //     footer: AppFooterWapMobiMath
    //   },
    //   props: {
    //     header: { colorOnScroll: 100 },
    //     footer: { backgroundColor: "black" }
    //   }
    // }
  ],
  mode: "history",
  // routes: [{ path: "/:pathMatch(.*)", component: NotFound }],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
